import React from "react";
import { useLocale } from "../../hooks";
import { useStaticQuery, graphql } from 'gatsby'
export const useSiteQuery = () => {
    const locale = useLocale();
    const {
        allContentfulEkaterraGlobalSite: { edges }
    } = useStaticQuery(
        graphql`
        query globalSite{
            allContentfulEkaterraGlobalSite {
                edges {
                    node {
                        node_locale
                        logo {
                            image {
                                fluid{
                                    ...GatsbyContentfulFluid_withWebp_noBase64
                                }
                                title
                            }
                            }
                        mobileLogo {
                            image {
                                fluid{
                                    ...GatsbyContentfulFluid_withWebp_noBase64
                                }
                                title
                            }
                            }
                        headerMenu {
                            name
                            title
                            slug
                            subLinks {
                                title
                                slug
                              }
                        }
                        copyrightsDescription {
                            raw
                          }
                        footerLinks {
                            name
                            title
                            slug
                            
                        }
                        footerSocialIcons {
                            image {
                                fluid{
                                    ...GatsbyContentfulFluid_withWebp_noBase64
                                }
                                title
                            }
                            slug
                          }
                        createdAt
                        newsletterPrivacyNotice {
                            raw
                        }
                        newsletter18Above
                        newsletterYesOrNo
                    }
                }
            }
        }`
    )

    

    const localeData = locale
        ? edges.filter(({ node }) => node.node_locale === locale)
        : edges.filter(({ node }) => node.node_locale === 'en-GB')
    const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})
    return site

}